export default __webpack_public_path__ + "static/media/error-404.b3b79cfa.svg";